export default "__VITE_ASSET__CNLgBgL6__"